import React from 'react';

import {
  SrcSet,
  ResponsiveImageUseCase,
} from '@shopee-user/business-customization-types';

// Android will support 1x, 2x, 3x and 4x while iOS only supports 1x, 2x and 3x
export default function ResponsiveImage({
  usecase,
  className,
  defaultSrc,
  srcSet,
}: {
  usecase?: ResponsiveImageUseCase;
  className?: string;
  defaultSrc: string;
  srcSet?: SrcSet[] | string;
}) {
  return (
    <img
      data-testid={usecase ? `responsive-image-${usecase}` : undefined}
      className={className}
      src={defaultSrc}
      srcSet={
        Array.isArray(srcSet)
          ? srcSet.map(({ src, size }) => `${src} ${size}`).join(', ')
          : srcSet || ''
      }
    />
  );
}
